module.exports = __webpack_public_path__ + "c462fd126cdef5c607100e47919cd77c.png";